import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { AppComponent } from '../app.component';
import { ApiRestService } from '../services/api-rest.service';
import { Router } from '@angular/router';
declare var $: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})


export class LoginComponent implements OnInit {

public href: string = "";

	config: any;
	loginForm : FormGroup;
	response = {
    "code": 0,
    "data": {
      "details": "",
      "auth_token": "",
      "ck": "",
      "sid": 1,
      "user_id": "",
      "id_platform": ""
    },
    "error_msj": "",
    "error_code": 0,
    "HasError": false,
    "status": false,
    "success": false,
    "result": false,
    "AlertType": "",
    "AlertMessage": "",
    "ModelErrors": [],
    "redirect_url": "",
    "Sess": ""
  };
  showError : boolean = false;
	email:string;
  password:string;
  click : boolean = true;
	

  constructor(
  	private appComponent: AppComponent,
  	private apiRestService: ApiRestService,
    private formBuilder: FormBuilder,
    private router: Router,
    private fb: FormBuilder

  	) { 
  		this.config = this.appComponent.config;

  }

  ngOnInit(): void {
      var vthis = this;
        this.loginForm = this.fb.group({
           email: new FormControl('', [
              Validators.required
            ]),
           password: new FormControl('', [
              Validators.required
            ])
        });
        if(this.loginForm.valid) {
          vthis.click = false;
        }
  }

  login(){
    var vthis = this;
      if(this.loginForm.valid){
        const login = {
          username: this.loginForm.value.email,
          password: this.loginForm.value.password,
        };
        const options = {
                    withCredentials: true
                };
        this.apiRestService.request('Login', login, options).subscribe((response) => {
          Object.assign(this.response, response);
          console.log(this.response);
          if(this.response.HasError == false || this.response.success){
            window.location.href = this.response.redirect_url + '?tt=' + this.response.Sess;
          }else{
           this.showError = true;
          }
        });
      }
      
    



  }

}
